import AppPopoverContent, { AppPopoverContentProps } from "../Popover/AppPopoverContent";

interface Props extends AppPopoverContentProps {}

export function CalendarEntryPopoverContent({ sx, children, ...otherProps }: Props) {
  return (
    <AppPopoverContent
      sx={{ minWidth: { xxs: 200, md: 300 }, py: 1, px: 1, ...sx }}
      {...otherProps}
    >
      {children}
    </AppPopoverContent>
  );
}
